module.exports = __webpack_public_path__ + "static/img/chanping1.3d45904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/chanping1.jpg
// module id = EM3w
// module chunks = 0